import {Component, Injector} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {usersGroup} from "../../resources/usersGroup";
import {ActivatedRoute, Route} from "@angular/router";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent{

    typeOfUser: string = '';
    constructor(public route: ActivatedRoute, public serviceInjector: Injector) {
        super(serviceInjector);

        this.typeOfUser = this.getUserType();
    }

    protected readonly usersGroup = usersGroup;
}
